
export class CandidatesByStatusResponse{
    body: KanbanResponseData;
    perPage: number;
    total: number;
  }

export interface KanbanResponseData {
    statuses: CandidatesByStatus[];
    availableJobTitles: string[];
  }

export class CandidatesByStatus{
    statusName: string;
    id: number;
    hrAssignedJobs: Array<any>
  }
